import React, { Component } from "react";
import { connect } from "react-redux";

import { BrowserView, MobileView } from "react-device-detect";
class DownloadableContent extends Component {
  render() {
    const { acf } = this.props;
    return (
      <>
        <BrowserView>
          <table
            className="downloads"
            cellSpacing="2"
            cellPadding="0"
            border="0"
            width="100%"
          >
            <tbody>
              {acf && acf.image && acf.image.url && (
                <tr>
                  <td>
                    <a
                      className="downloadBtn"
                      href={acf.image.url}
                      download={acf.image.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Lae alla pilt
                    </a>
                  </td>
                </tr>
              )}
              {acf && acf.tootekaart && acf.tootekaart && (
                <tr>
                  <td>
                    <a
                      className="downloadBtn"
                      href={acf.tootekaart.url}
                      download={acf.tootekaart.filename}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Lae alla tootekaart
                    </a>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </BrowserView>
        <MobileView>
          <table
            className="mobileDownloads"
            cellSpacing="5"
            cellPadding="0"
            border="0"
            width="100%"
          >
            <tbody>
              {" "}
              <tr>
                {acf && acf.image && acf.image.url && (
                  <td>
                    <a
                      className="downloadBtn"
                      href={acf.image.url}
                      download={acf.image.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Lae alla pilt
                      <img
                        className="downloadIcon"
                        src={process.env.PUBLIC_URL + "/img/download.png"}
                        alt="download"
                      />
                    </a>
                  </td>
                )}
                {acf && acf.tootekaart && acf.tootekaart && (
                  <td>
                    <a
                      className="downloadBtn"
                      href={acf.tootekaart.url}
                      download={acf.tootekaart.filename}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Lae alla tootekaart
                      <img
                        className="downloadIcon"
                        src={process.env.PUBLIC_URL + "/img/download.png"}
                        alt="download"
                      />
                    </a>
                  </td>
                )}{" "}
              </tr>
            </tbody>
          </table>
        </MobileView>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, {})(DownloadableContent);
